import Header from 'components/headers/bulletins'
import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import posthog from 'posthog-js'
import SubHeader from './subheader'
import useGetLoans from './hooks/useGetLoans'
import Loans from './loans'
import DotsLoading from 'components/loadings/dotsLoading'
import useGetMoneyPoolManagement from '../fundPage/hooks/useGetMoneyPoolManagement'
import useGetSubHeaderLoans from './hooks/useGetSubHeaderLoans'
import CustomBottomSheet from 'components/bottomSheet'
import LoanGuarantors from './LoanGuarantors'
import DemandLink from './DemandLink'
import GuarantorNudge from 'components/guarantorNudge'
import { toast } from 'react-toastify'

export default function UserFundsDetail() {
    const [isOpenLink, setIsOpenLink] = useState<boolean>(false)
    const { moneyPool, loanId } = useParams()
    const { state } = useLocation()
    const { data, isLoading } = useGetLoans()
    useEffect(() => {
        posthog.capture('loan_detail_viewed', {
            fund_id: moneyPool,
            loan_id: loanId,
        })
    }, [moneyPool, loanId])
    const { moneyPoolManagement } = useGetMoneyPoolManagement(moneyPool)
    const { subHeaderData } = useGetSubHeaderLoans(
        data?.results.installments[0].loan
    )
    // `state.name` is the borrower, handed over by whichever list linked here.
    // Reloading the page (or opening the link directly) arrives with no router
    // state at all, and reading `.name` off it threw straight into the error
    // boundary — a refresh on this screen showed «باگ خوردیم». The borrower is
    // on the installments payload anyway.
    const borrowerName =
        state?.name ?? data?.results.installments[0]?.poolship_name ?? ''

    return (
        <div className="bg-canvas min-h-screen pb-6">
            <Header title={borrowerName ? `وام ${borrowerName}` : 'وام'} />
            {subHeaderData ? (
                <>
                    <SubHeader
                        data={subHeaderData}
                        setIsOpenLink={setIsOpenLink}
                    />
                    <LoanGuarantors
                        moneypoolId={moneyPool}
                        loanId={loanId}
                        borrowerPoolshipId={
                            data?.results.installments[0].poolship
                        }
                        isManager={
                            moneyPoolManagement?.poolship?.role === 'mgr' ||
                            moneyPoolManagement?.poolship?.role === 'own'
                        }
                    />
                    {/* قسط عقب افتاده: پیگیری از ضامن‌ها — managers only,
                        shown only while something is late */}
                    <GuarantorNudge
                        moneypoolId={moneyPool}
                        target={loanId ? { kind: 'loan', loanId } : null}
                        isManager={
                            moneyPoolManagement?.poolship?.role === 'mgr' ||
                            moneyPoolManagement?.poolship?.role === 'own'
                        }
                    />
                </>
            ) : (
                <DotsLoading />
            )}
            {/* the way back to the درخواست this loan came from — the
                thread the manager wrote the guarantee-cheque number in.
                Absent for a directly granted loan, and for a member who is
                neither the borrower nor a manager: the server decides. */}
            {data?.results.loan_demand && (
                <DemandLink
                    demand={data.results.loan_demand}
                    fundId={moneyPool}
                />
            )}

            {data && !isLoading ? (
                <Loans
                    data={data.results.installments}
                    poolshipId={data.results.installments[0]?.poolship}
                    fundName={moneyPoolManagement && moneyPoolManagement.name}
                />
            ) : (
                <DotsLoading />
            )}
            {subHeaderData && (
                <CustomBottomSheet
                    isOpen={isOpenLink}
                    onDismiss={() => setIsOpenLink(false)}
                >
                    <div>
                        {/* The link being shared is the LOAN's `short_url` —
                            it opens the installment payment page. Calling it
                            «حق عضویت» named the fund's own dues link, which is
                            a different link on a different screen. */}
                        <p className="text-center font-bold text-heading mb-3">
                            اشتراک‌گذاری لینک پرداخت اقساط
                        </p>
                        <hr className="border-divider" />
                        <div className="my-4 px-3">
                            <p
                                className="text-center text-lg my-2 py-2 text-text-body active:scale-[0.98] transition-transform cursor-pointer"
                                onClick={() => {
                                    navigator.clipboard.writeText(
                                        subHeaderData?.short_url
                                    )
                                    toast.success('لینک با موفقیت کپی شد')
                                    setIsOpenLink(false)
                                }}
                            >
                                کپی لینک
                            </p>
                            <p
                                className="text-center text-lg my-2 py-2 text-text-body active:scale-[0.98] transition-transform cursor-pointer"
                                onClick={() => {
                                    // navigator.share is absent on desktop
                                    // browsers and rejects when the user
                                    // dismisses the sheet; either way an
                                    // unhandled throw left the row doing
                                    // nothing at all.
                                    if (!navigator.share) {
                                        navigator.clipboard.writeText(
                                            subHeaderData.short_url
                                        )
                                        toast.success(
                                            'اشتراک‌گذاری در این مرورگر نیست؛ لینک کپی شد'
                                        )
                                        setIsOpenLink(false)
                                        return
                                    }
                                    navigator
                                        .share({
                                            url: subHeaderData.short_url,
                                            title: 'پرداخت قسط وام',
                                        })
                                        .catch(() => undefined)
                                    setIsOpenLink(false)
                                }}
                            >
                                سایر اپلیکیشن‌ها
                            </p>
                        </div>
                    </div>
                </CustomBottomSheet>
            )}
        </div>
    )
}
